import * as React from 'react';
import { Escape } from '@fluentui/keyboard-keys';
/**
 * Checks if keydown event is a proper Escape key dismiss
 */ export function isEscapeKeyDismiss(event, modalType) {
    return event.key === Escape && modalType !== 'alert' && !event.isDefaultPrevented();
}
